import { FormUtil } from '../components/common/FormUtil';
import { jobTypesIdEnum } from '../models-enums';

export const jobTypeOptions = FormUtil.convertEnumToOptions(jobTypesIdEnum);
